<div class="eol-home">
    <h1 class="eol-home__heading">Online Term Life Insurance</h1>
    <div class="eol-home__section-divider"></div>
    <div class="eol-home__content-section">
        <h2 class="eol-home__subheading">View your MassMutual® Direct Term policy</h2>
        <p>Have you applied for or purchased a MassMutual® Direct Term policy? Log in to view your policy.</p>
        <button cpdsButton theme="mm-light" variant="secondary" (click)="login()">
            Log in to MassMutual® Direct
        </button>
    </div>
    <div class="eol-home__section-divider"></div>
    <div class="eol-home__content-section">
        <img class="eol-home__section-logo" src="/img/logo/haven-life-primary-blue.svg" alt="Haven Life" />
        <h2 class="eol-home__subheading">Apply for a term life policy</h2>
        <p>
            With Haven Life, you can apply online for a term life policy issued by MassMutual or its subsidiary, 
            C.M. Life, and get an instant decision on eligibility.
        </p>
        <a cpdsButton [href]="dtcUrl" theme="mm-light">
            Visit Haven Life
            <cpds-icon icon="expand"></cpds-icon>
        </a>
    </div>
</div>
